import React from 'react'
import { Form } from 'antd'
import { FormItemProps as FormItemPropsAnd } from 'antd/lib/form'
import {
  OptionProps as OptionPropsAntd,
  SelectProps as SelectPropsAntd
} from 'antd/lib/select'
import { useT } from 'src/core/hooks/use-translation'

import * as CSS from './styles'

export type Option = OptionPropsAntd & {
  label: string
}

export type Props = Pick<SelectPropsAntd, 'loading' | 'placeholder' | 'size'> &
  Pick<FormItemPropsAnd, 'label' | 'required'> & {
    fakeOptions: Option
    formikProps?: any
    name?: string
  }

export function SelectFake({
  fakeOptions,
  formikProps,
  label,
  name,
  required,
  size = 'large'
}: Props) {
  const { t } = useT()

  const fakeOptionsLabel = fakeOptions?.label || fakeOptions?.title || ''
  const fakeOptionsTitle = fakeOptions?.title || fakeOptions?.label || ''
  const fakeOptionsValue = '-1'

  const hasError = formikProps?.errors?.[name]
  const hasTouched = formikProps?.touched?.[name]
  const validateStatus =
    hasError && hasTouched
      ? 'error'
      : (!hasError && hasTouched && 'success') || ''

  return (
    <Form.Item
      colon={false}
      hasFeedback
      help={(hasTouched && typeof hasError === 'string' && t(hasError)) || ''}
      label={(typeof label === 'string' && t(label)) || label}
      required={required}
      validateStatus={validateStatus}
    >
      <CSS.Select loading placeholder={fakeOptionsLabel} size={size}>
        <CSS.Select.Option
          disabled
          key={0}
          title={fakeOptionsTitle}
          value={fakeOptionsValue}
        />
      </CSS.Select>
    </Form.Item>
  )
}
